import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "input-password-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-content"
};
const _hoisted_5 = {
  class: "input-label"
};
const _hoisted_6 = {
  class: "input-row"
};
const _hoisted_7 = {
  class: "input-box with-suffix"
};
const _hoisted_8 = {
  class: "suffix-wrap"
};
import { ref } from 'vue';
export default {
  __name: 'InputPassword',
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: /*#__PURE__*/_mergeModels(['onClose', 'onConfirm'], ["update:modelValue"]),
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const model = _useModel(__props, "modelValue");
    const showPassword = ref(false);
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('user.withdrawPassword')), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_form, {
          class: "input-form style2",
          onSubmit: _cache[3] || (_cache[3] = $event => emit('onConfirm'))
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('label.pwd')) + ":", 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
            class: "prefix-img",
            src: require('@/assets/img/user/password/lock.png')
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_field, {
            modelValue: model.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => model.value = $event),
            modelModifiers: {
              trim: true
            },
            class: "input-field",
            placeholder: _ctx.$t('placeholder.pwd'),
            type: !showPassword.value ? 'password' : 'text',
            clearable: ""
          }, null, 8, ["modelValue", "placeholder", "type"]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createVNode(_component_van_icon, {
            class: "eye-icon",
            name: !showPassword.value ? 'eye-o' : 'closed-eye',
            onClick: _cache[2] || (_cache[2] = $event => showPassword.value = !showPassword.value)
          }, null, 8, ["name"]), [[_directive_audio]])])])]), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
            "native-type": "submit",
            class: "confirm-btn",
            disabled: !model.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)]),
            _: 1
          }, 8, ["disabled"])), [[_directive_audio]])]),
          _: 1
        })])])]),
        _: 1
      })]);
    };
  }
};